<template>
  <v-container
    class="mx-500 py-12 py-md-0 px-7 px-md-5 pa-md-13 species-container"
  >
    <v-row>
      <v-col>
        <div id="attachautocomplete" class="position-relative">
          <v-autocomplete
            :search-input.sync="speciesFilter"
            v-model="fakeObject"
            @input="speciesSelected"
            :items="species"
            :multiple="false"
            :hide-selected="false"
            solo
            :filter="() => true"
            return-object
            :loading="false"
            attach="#attachautocomplete"
            item-text="name"
            label="Search"
            append-icon="$search"
            class="font-weight-bold"
            :filled="true"
            color="black"
          >
            <template v-slot:selection="{ item }">
              <div>
                <v-avatar tile small contain size="50">
                  <v-img :src="getMedia(item)" :alt="item.name" />
                </v-avatar>

                {{ item.name }}
              </div>
            </template>
            <template v-slot:item="{ item }">
              <v-list-item-avatar tile small contain size="50">
                <img :src="getMedia(item)" :alt="item.name" />
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title v-html="item.name" />
              </v-list-item-content>
            </template>
          </v-autocomplete>
        </div>
      </v-col>
    </v-row>
    <v-skeleton-loader
      v-if="!nearBySpeciesModel.fetched || nearBySpeciesModel.fetching"
      height="180"
      type="table-tbody"
    />
    <v-row class="mb-6" v-else-if="nearBySpecies.length">
      <v-col cols="12" class="pb-4">
        <h2 class="title font-weight-bold">Nearby</h2>
      </v-col>
      <v-col
        v-for="(species, index) in nearBySpecies"
        :key="`nearyby-${index}`"
        class="d-flex child-flex pt-0"
        cols="6"
      >
        <v-card class="position-relative" @click="speciesSelected(species)">
          <v-img
            fill
            :src="getMedia(species)"
            :alt="species.name"
            lazy-src="/placeholder.jpg"
            aspect-ratio="1.1428"
            class="white--text align-end"
          >
            <v-chip
              v-if="species.tour_distance_in_km"
              class="white position-absolute py-0"
              style="font-size: 11px; font-weight: bold; top:10px; right: 10px; z-index: 10"
            >
              {{ species.tour_distance_in_km }} km
            </v-chip>
            <v-card-title class="font-weight-bold headline">
              {{ species.name }}
            </v-card-title>
          </v-img>
        </v-card>
      </v-col>
    </v-row>
    <v-row class="mb-12">
      <v-col cols="12">
        <h2 class="title font-weight-bold">Filter by Family</h2>
      </v-col>
      <v-col
        v-for="(family, index) in families.slice(0, 9)"
        :key="`family-${index}`"
        class="d-flex child-flex"
        cols="6"
      >
        <v-card
          :ripple="false"
          class="d-flex custom-shaped"
          @click="filterByFamilies(family)"
          v-bind="selectedFamily === family.id ? { shaped: true } : {}"
        >
          <v-img
            fill
            :src="getMedia(family)"
            :alt="family.name"
            lazy-src="/placeholder.jpg"
            class="white--text align-center"
            aspect-ratio="1"
          >
            <v-card-title class="font-weight-bold title lh-1 text-center pa-2">
              {{ family.name }}
            </v-card-title>
          </v-img>
        </v-card>
      </v-col>
    </v-row>

    <v-row class="mb-23">
      <v-col cols="12" class="py-0">
        <h2 class="title font-weight-bold mb">Learn</h2>
      </v-col>
      <v-col cols="12">
        <v-list-item
          class="pa-0 d-flex flex-column justify-start align-start flex-fill"
        >
          <v-list-item-content class="d-block w-100  py-2">
            <v-list-item-title class="grey--text">
              Can't find it
            </v-list-item-title>
          </v-list-item-content>
          <v-list-item-content class="d-block w-100 py-2">
            <v-list-item-title class="grey--text ">
              What species do we track
            </v-list-item-title>
          </v-list-item-content>
          <v-list-item-content class="d-block w-100 py-2">
            <v-list-item-title class="grey--text">
              How is the data handled?
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Model from '@models/SpeciesFamily';
import Species from '@models/Species';
import TourRequest from '@request/TourRequest';

export default {
  name: 'SelectSpecies',
  props: {
    request: {
      type: TourRequest,
      required: true,
    },
  },
  data() {
    return {
      model: new Model({
        relations: ['species'],
      }),
      speciesModel: new Species({
        itemsPerPage: 5,
        page: 1,
        relations: ['family', 'media'],
      }),
      nearBySpeciesModel: new Species({
        itemsPerPage: 2,
        page: 1,
        relations: ['family', 'media'],
        sortBy: ['nearest'],
      }),
      speciesFilter: null,
      species: [],
      selectedSpecies: [],
      selectedFamily: '',
      fakeObject: {},
      families: [],
      user: this.$store.state.auth.user,
      nearBySpecies: [],
      mounted: false,
    };
  },
  watch: {
    speciesFilter: {
      handler(search) {
        if (!this.mounted) {
          return;
        }
        this.speciesModel.setFilters({
          name: search,
        });
        this.fetchSpecies();
      },
      immediate: false,
    },
    selectedFamily: {
      handler() {
        if (!this.mounted) {
          return;
        }
        this.fetchSpecies();
      },
      immediate: false,
    },
  },
  methods: {
    async fetchFamilies() {
      let response = await this.model.get();
      if (response) {
        this.families = response.data;
      }
    },
    async fetchSpecies() {
      this.speciesModel.setFilters({
        family_id: this.selectedFamily,
        name: this.speciesFilter,
      });
      let response = await this.speciesModel.get();
      if (response) {
        this.species = response.data;
      }
    },
    async fetchNearBySpecies() {
      if (this.user.business && this.user.business.location) {
        this.nearBySpeciesModel.setFilters({
          coordinates: `${this.user.business.location.lat},${this.user.business.location.lng}`,
        });
        let response = await this.nearBySpeciesModel.get();
        if (response) {
          this.nearBySpecies = response.data;
        }
      } else {
        this.nearBySpeciesModel.fetched = true;
      }
    },
    speciesSelected(species) {
      this.fakeObject = {};
      this.speciesFilter = '';
      if (new Set(this.request.species_ids).has(species.id)) {
        $showInfo(
          'This species has already been selected',
          'species-selection'
        );
        return;
      }
      this.request.species_ids.push(species.id);
      this.request.species.push({ ...species, ...{ isNew: true } });
    },
    filterByFamilies(family) {
      this.selectedFamily = family.id;
    },
  },
  created() {
    this.fetchFamilies();
    this.fetchSpecies();
    this.fetchNearBySpecies();
  },
  mounted() {
    this.mounted = true;
  },
};
</script>
<style lang="scss">
.custom-shaped {
  &.v-card--shaped {
    border-radius: 24px 12px !important;
  }

  &.v-sheet--shaped {
    border-radius: 24px 12px !important;
  }

  &.v-card--link {
    &::before {
      background: none;
    }
  }
}
</style>
